var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications scrollable -y scrollbar-hidden"},[_c('transition-group',{attrs:{"name":"fade","mode":"out-in"}},_vm._l((_vm.toasterItems),function(item,key){return _c('div',{key:key,staticClass:"toaster-wrapper"},[_c('div',{staticClass:"toaster",class:{
        'success': item.status === 'success',
        'info': item.status === 'info',
        'warning': item.status === 'warning',
        'error': item.status === 'error',
      },on:{"click":function($event){_vm.onClickToaster(key)}}},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(item.message))])])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9295222","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account/Notifications.vue
// module id = 136
// module chunks = 1